import { makeStyles } from "@material-ui/core/styles";

export const DAMAGE_PREVIEW_SIZE = 400;

export const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    padding: "40px",
    height: "inherit",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      overflow: "auto",
    },
  },
  damagesContainer: {
    marginRight: 70,
    [theme.breakpoints.down("md")]: {
      margin: "0 auto 30px",
    },
  },
  damagesPreview: {
    position: "relative",
    height: DAMAGE_PREVIEW_SIZE,
    width: DAMAGE_PREVIEW_SIZE,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  skeleton: {
    maxWidth: "100%",
    maxHeight: "100%",
  },
  markContainer: {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    zIndex: 1,
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    padding: 0,
  },
  mark: {
    borderRadius: "50%",
    width: 22,
    height: 22,
    border: "3px solid #fff",
    boxSizing: "border-box",
    "&--active": {
      "&:before": {
        content: "''",
        display: "block",
        position: "absolute",
        width: 94,
        height: 94,
        opacity: 0.3,
        backgroundColor: "inherit",
        borderRadius: "50%",
        transform: "translate(-50%, -50%)",
        top: "50%",
        left: "50%",
        zIndex: -1,
      },
    },
  },
  damageList: {
    minWidth: 300,
    overflow: "auto",
    flex: 1,
    paddingRight: 30,
    [theme.breakpoints.down("md")]: {
      overflow: "unset",
    },
  },
  damageListTitle: {
    fontSize: 16,
  },
  damageListHint: {
    display: "inline-block",
    marginTop: 20,
    color: "#828282",
  },
  damageActions: {
    display: "flex",
    marginLeft: 10,
  },
  damageAction: {
    cursor: "pointer",
    marginLeft: 10,
  },
  damage: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    paddingLeft: 25,
    borderLeft: "2px solid",
    marginBottom: 20,
    "&--inactive": {
      opacity: 0.5,
    },
  },
  damageType: {
    fontSize: 16,
    fontWeight: 500,
    textTransform: "capitalize",
  },
  damagePhoto: {
    width: 100,
    height: 100,
    objectFit: "fill",
    marginRight: 10,
    marginTop: 10,
    cursor: "pointer",
  },
  damagePhotoPreview: {
    width: 100,
    height: 100,
    objectFit: "fill",
    marginRight: 10,
    marginTop: 10,
  },
  viewDamagePhoto: {
    display: "block",
    margin: "0 auto",
  },
}));
